import { dataURItoBlob } from './data-blob';

export const dpi = 300;
export const maxImageWidth = 297 / 3;
export const maxImageHeight = 210 / 2;
export const toPixel = dpi / 25.4;
export const mmPrintMargin = 3 * toPixel;

export function clearImagePart(canvas: CanvasRenderingContext2D, x: number, y: number) {
    canvas.beginPath()
    canvas.rect(x, y, maxImageWidth * toPixel, maxImageHeight * toPixel);
    canvas.fillStyle = '#fff';
    canvas.fill();
}

export async function drawImage(canvas: CanvasRenderingContext2D, imageURI: string, blurImage: boolean, x: number, y: number) {
    const imageBlob = dataURItoBlob(imageURI);

    return new Promise((resolve, reject) => {
        clearImagePart(canvas, x, y)

        const reader = new FileReader();
        reader.readAsDataURL(imageBlob);
        reader.onload = function () {
            const img = new Image();
            img.src = reader.result ?? '';
            img.onerror = function (error) {
                console.error('Error loading image:', error);
                reject(error);
            }
            img.onload = function () {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;

                const maxWidth = maxImageWidth * toPixel - 2 * mmPrintMargin;
                const maxHeight = maxImageHeight * toPixel - 2 * mmPrintMargin;

                let newWidth = maxWidth;
                let newHeight = maxWidth / ratio;

                if (newHeight > maxHeight) {
                    newHeight = maxHeight;
                    newWidth = maxHeight * ratio;
                }

                const startX = x + mmPrintMargin + (maxWidth - newWidth) / 2;
                const startY = y + mmPrintMargin + (maxHeight - newHeight) / 2;

                canvas.drawImage(img, startX, startY, newWidth, newHeight);

                if (blurImage) {
                    // Draw a blurry/transparent border on the inside of the image
                    const blurSize = 10 * toPixel;

                    // Top
                    canvas.beginPath();
                    canvas.rect(startX, startY, newWidth, blurSize);
                    // Gradient from top 100% transparent white to bottom 0% transparent
                    let gradient = canvas.createLinearGradient(startX, startY, startX, startY + blurSize);
                    gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
                    canvas.fillStyle = gradient;
                    canvas.fill();

                    // Bottom
                    canvas.beginPath();
                    canvas.rect(startX, startY + newHeight - blurSize, newWidth, blurSize);
                    // Gradient from bottom 100% transparent to top 100% opaque
                    gradient = canvas.createLinearGradient(startX, startY + newHeight - blurSize, startX, startY + newHeight);
                    gradient.addColorStop(0, 'rgba(255, 255, 255, 0)');
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 1)');
                    canvas.fillStyle = gradient;
                    canvas.fill();

                    // Left
                    canvas.beginPath();
                    canvas.rect(startX, startY, blurSize, newHeight);
                    // Gradient from left 100% transparent to right 100% opaque
                    gradient = canvas.createLinearGradient(startX, startY, startX + blurSize, startY);
                    gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
                    canvas.fillStyle = gradient;
                    canvas.fill();

                    // Right
                    canvas.beginPath();
                    canvas.rect(startX + newWidth - blurSize, startY, blurSize, newHeight);
                    // Gradient from right 100% transparent to left 100% opaque
                    gradient = canvas.createLinearGradient(startX + newWidth - blurSize, startY, startX + newWidth, startY);
                    gradient.addColorStop(0, 'rgba(255, 255, 255, 0)');
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 1)');
                    canvas.fillStyle = gradient;
                    canvas.fill();
                }

                resolve(undefined)
            }
        }
    })
}
